import React, { lazy, Suspense } from 'react'
import { WelcomeProps } from '../types'
import { VacancyMeetingMode } from 'api/endpoints/openapi-generated.schemas'
import { LoadingPage } from '../loading'

const WelcomeChatOnlyDynamic = lazy(() =>
  import('../call-chat').then((x) => ({ default: x.WelcomeChatOnly }))
)
const Welcome11LabsDynamic = lazy(() =>
  import('../call-11labs').then((x) => ({ default: x.Welcome11Labs }))
)
const WelcomeHeygenDynamic = lazy(() =>
  import('../call-heygen').then((x) => ({ default: x.WelcomeHeygen }))
)

export const Welcome: React.FC<WelcomeProps> = (props) => {
  const {
    vacancy: { meeting_mode: meetingMode },
    vacancyUiSettings: { welcome_screen: welcomeUi }
  } = props

  if (!welcomeUi) {
    return <div>Error! No welcome screen settings found</div>
  }

  if (meetingMode === VacancyMeetingMode.chat_only) {
    return (
      <Suspense
        fallback={
          <LoadingPage
            tag={'Suspense fallback (LoadingPage): WelcomeChatOnlyDynamic'}
          />
        }
      >
        <WelcomeChatOnlyDynamic {...props} />
      </Suspense>
    )
  }

  if (meetingMode === VacancyMeetingMode.voice_only) {
    return (
      <Suspense
        fallback={
          <LoadingPage
            tag={'Suspense fallback (LoadingPage): Welcome11LabsDynamic'}
          />
        }
      >
        <Welcome11LabsDynamic {...props} />
      </Suspense>
    )
  }

  return (
    <Suspense
      fallback={
        <LoadingPage
          tag={'Suspense fallback (LoadingPage): WelcomeHeygenDynamic'}
        />
      }
    >
      <WelcomeHeygenDynamic {...props} />
    </Suspense>
  )
}
